export default class Animations {
    static init() {
        return new Animations();
    }

    constructor() {
        var items = document.querySelectorAll('.split-text');

        if (!items)
            return;

        items.forEach(item => {
            item.innerHTML = '<div><span>' + item.textContent.trim().split('').join('</span><span>') + '</span></div>';
        })
    }
}